<template>
  <div>
    <div v-if="!isMobile" class="vitrinHeader h-[200px] flex flex-col content-between">
      <div class="flex justify-center pt-13">
        <div class="flex justify-center items-center">
          <div class="w-20 h-px bg-[#FDCDC2] mr-4" />
          <OIcon icon="vitrin/header/vitrin-header-logo" svg-class="w-[130px] h-[34px] text-[#FF7352]" />
          <div class="w-20 h-px bg-[#FDCDC2] ml-4" />
        </div>
      </div>

      <div class="bg-color-[#FFDDD4] overflow-x-scroll sm:overflow-x-hidden overflow-y-hidden flex items-end mt-10 mx-auto">
        <OLink
          class="vitrinHeader-categories-link w-24 relative pb-5 flex flex-col items-center"
          :class="{ isActive: $route.path === '/vitrin' }"
          pure
          href="/vitrin"
          selected
          draggable="false"
        >
          <OIcon icon="vitrin/header/category-tumu" svg-class="w-[26px] h-[26px] mb-2 mt-auto text-[#323254]" />
          <p class="vitrinHeader-categories-title text-[#323254] font-semibold text-base">Tümü</p>
        </OLink>
        <OLink
          v-for="(element, index) in categories"
          :key="index"
          class="vitrinHeader-categories-link w-24 relative pb-5 flex flex-col items-center"
          :class="{ isActive: $route.path === getCategoryPath(element) }"
          pure
          :href="getCategoryPath(element)"
          draggable="false"
        >
          <OIcon
            :icon="getIconPath(element.name)"
            :svg-class="`${element.issyncdata && 'w-[26px]'} h-[26px] mb-2 mt-auto text-[#323254]`"
          />
          <p class="vitrinHeader-categories-title text-[#323254] font-semibold text-base whitespace-nowrap">{{ element.name }}</p>
        </OLink>
      </div>
    </div>

    <div v-else class="vitrinHeader h-[140px] bg-none flex flex-col">
      <div class="vitrinHeader-logo-mobile flex justify-between">
        <div class="flex justify-center items-center p-4">
          <OIcon icon="vitrin/header/vitrin-header-logo" svg-class="w-[100px] h-[26px] text-[#FF7352]" />
        </div>
        <div class="vitrinHeader-logo-mobile-background h-full" />
      </div>

      <div class="bg-color-[#FFDDD4] overflow-x-scroll sm:overflow-x-hidden overflow-y-hidden flex items-end justify-start">
        <OLink
          class="vitrinHeader-categories-link relative flex flex-col items-center mx-5 py-3"
          :class="{ isActive: $route.path === '/vitrin' }"
          pure
          href="/vitrin"
          draggable="false"
        >
          <OIcon icon="vitrin/header/category-tumu" svg-class="w-[26px] h-[26px] mb-2 mt-auto text-[#323254]" />
          <p class="vitrinHeader-categories-title text-[#323254] font-semibold text-base">Tümü</p>
        </OLink>
        <OLink
          v-for="element in categories"
          :id="$route.path === getCategoryPath(element) ? 'selectedCategory' : undefined"
          :key="element.id"
          class="vitrinHeader-categories-link relative flex flex-col items-center mx-5 py-3"
          :class="{ isActive: $route.path === getCategoryPath(element) }"
          pure
          :href="getCategoryPath(element)"
          draggable="false"
        >
          <OIcon
            :icon="getIconPath(element.name)"
            :svg-class="`${element.issyncdata && 'w-[26px]'} h-[26px] mb-2 mt-auto text-[#323254]`"
          />
          <p class="vitrinHeader-categories-title text-[#323254] font-semibold text-base whitespace-nowrap">{{ element.name }}</p>
        </OLink>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { normalizeText } from '~/modules/common/utils/stringUtils';
import { OLink, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink, OIcon },
  props: {
    categories: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { isMobile } = useDevice();

    onMounted(() => {
      const selected = document.getElementById('selectedCategory');
      if (selected) {
        selected.scrollIntoView({ block: 'end', inline: 'center' });
      }
    });

    const getCategoryPath = (category) => {
      return `/vitrin/${normalizeText(category.name)}`;
    };

    const getIconPath = (name) => `vitrin/icons/${normalizeText(name)}`;

    return { isMobile, getCategoryPath, getIconPath };
  },
});
</script>

<style scoped lang="scss">
.vitrinHeader {
  background: #ffddd4 url('/images/vitrin/vitrin-header-desktop-logo.svg') center;
  &-logo {
    &-mobile {
      background: #ffddd4;
      border: 1px solid #fdcdc2;
      &-background {
        background: #ffddd4 url('/images/vitrin/vitrin-header-mobile-background.svg') no-repeat;
        background-size: cover;
        width: 170px;
      }
    }
  }
  &-categories {
    &-link {
      border-bottom: 3px solid transparent;
      &:hover,
      &.isActive {
        border-bottom-color: #323254;
        &:before {
          background-color: #323254;
          content: '';
          width: 8px;
          height: 6.4px;
          clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translate(-50%, 0);
        }
      }
    }
    &-title {
      line-height: 18px !important;
      letter-spacing: -0.3px;
    }
  }
}
</style>
